module.exports = __webpack_public_path__ + "static/media/rumba.f614aceb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/rumba.gif
// module id = 248
// module chunks = 0